<template>
    <page :busy="busy">
        <div style="padding: 5px;">
            <h4>Conversion Rate of First Time Guests to Recurring Guests Since Staylio Launch</h4>
        </div>
        <vue-apex-charts type="bar" :options="options" :series="series" width="100%" height="400" />
    </page>
</template>

<script>
    import { mapGetters } from 'vuex';
    import API from '../../../api';
    import { STAYLIO_APP_STATISTICS_USER_ENDPOINT } from '../../../endpoints';
    import page from '../../generic/page/page.vue';
    import VueApexCharts from 'vue3-apexcharts';

    export default {
        components: {
            page,
            VueApexCharts,
        },
        name: 'StaylioAppConversion',
        data() {
            return {
                busy: false,
                conversion_data: [],
                series: [],
                categories: [],
            };
        },
        computed: {
            ...mapGetters('header', ['userUnicodeDateFormat', 'userCurrencySymbol']),

            options() {
                return {
                    chart: {
                        type: 'bar',
                        width: '100%',
                        height: 400,
                        zoom: {
                            enabled: false,
                        },
                    },
                    yaxis: {
                        max: 100,
                        labels: {
                            formatter: (val) => `${val}%`,
                        },
                    },
                    xaxis: {
                        categories: this.categories,
                    },
                    dataLabels: {
                        enabled: true,
                        formatter: (val, { dataPointIndex, w }) => {
                            if (val === 0) {
                                return ``;
                            } else {
                                return `${val}%`;
                            }
                        },
                        offsetY: -20,
                        style: {
                            fontSize: '12px',
                            colors: ['#304758'],
                        },
                    },
                    plotOptions: {
                        bar: {
                            dataLabels: {
                                position: 'top',
                            },
                        },
                    },
                    tooltip: {
                        shared: true,
                        intersect: false,
                    },
                };
            },
        },
        async mounted() {
            Promise.all([this.getConversionData()]);
        },
        methods: {
            async getConversionData() {
                this.busy = true;
                const { data } = await API.get(`${STAYLIO_APP_STATISTICS_USER_ENDPOINT()}guest-conversion/`);
                this.conversion_data = data;

                let w_staylio = [];
                let wo_staylio = [];

                for (let i = 0; i < this.conversion_data.length; i++) {
                    w_staylio.push(this.conversion_data[i].conversion_rate_app.toFixed(2));
                    wo_staylio.push(this.conversion_data[i].conversion_rate_no_app.toFixed(2));
                    this.categories.push(this.conversion_data[i].booking_method);
                }

                this.series = [
                    { data: w_staylio, name: 'Conversion Rate with Staylio', color: '#33de72' },
                    { data: wo_staylio, name: 'Conversation Rate without Staylio', color: '#de3333' },
                ];

                this.busy = false;
            },
        },
    };
</script>

<style lang="scss" scoped></style>
